import { AutoComplete } from "primereact/autocomplete";
import { useEffect, useMemo, useState } from "react";
import {
  buscarMercaderiasPorTexto,
  crearControladorBusquedaMercaderias,
  crearFiltrosMercaderiaDesdeTexto,
  evaluarFiltrosMercaderia,
  formatearMercaderia,
} from "../servicios/mercaderiasPiSeun";

export default function BuscadorMercaderias({
  Buscar,
  LimpiarResultados,
  Seleccionado,
  setValor,
  SoloLectura = false,
  TituloNoSeleccionado = "Buscar por código o descripción",
}) {
  const [valor, setValorLocal] = useState(Seleccionado ?? "");
  const [consulta, setConsulta] = useState("");
  const [resultados, setResultados] = useState([]);
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (Seleccionado && typeof Seleccionado === "object") setValorLocal(Seleccionado);
    if (!Seleccionado) setValorLocal("");
  }, [Seleccionado]);

  const controlador = useMemo(
    () => crearControladorBusquedaMercaderias({
      consultar: async (filtros, signal) => {
        return buscarMercaderiasPorTexto(Buscar, filtros.codigo, signal);
      },
      alLimpiar: () => {
        setResultados([]);
        setBusquedaRealizada(false);
        setError("");
        LimpiarResultados?.();
      },
      alBuscar: () => {
        setBusquedaRealizada(false);
        setError("");
      },
      alResolver: (lista) => {
        setResultados(Array.isArray(lista) ? lista : []);
        setBusquedaRealizada(true);
      },
      alError: (e) => {
        setResultados([]);
        setBusquedaRealizada(true);
        setError(e?.message || "No se pudieron buscar las mercaderías.");
      },
    }),
    [Buscar, LimpiarResultados],
  );

  useEffect(() => () => controlador.destruir(), [controlador]);

  const buscar = ({ query }) => {
    const texto = String(query ?? "").trim();
    setConsulta(texto);
    LimpiarResultados?.();
    controlador.actualizar(crearFiltrosMercaderiaDesdeTexto(texto));
  };

  const cambiar = (event) => {
    setValorLocal(event.value);
    setValor(event.value || null);
    if (!event.value) {
      setConsulta("");
      controlador.actualizar({ codigo: "", descripcion: "" });
    }
  };

  const evaluacion = evaluarFiltrosMercaderia(crearFiltrosMercaderiaDesdeTexto(consulta));
  const mensajeVacio = error
    || (!evaluacion.vacio && !evaluacion.valido ? "Ingrese al menos 1 carácter" : "")
    || (busquedaRealizada ? "Sin resultados" : TituloNoSeleccionado);

  return (
    <div className="mercaderias-buscador">
      <AutoComplete
        className="lista-desplegable"
        style={{ width: "100%" }}
        inputStyle={{ backgroundColor: "white", width: "100%", color: "black", fontSize: "14px", fontWeight: "bold" }}
        value={valor}
        suggestions={!SoloLectura ? resultados : []}
        completeMethod={buscar}
        delay={0}
        onChange={cambiar}
        field="sDescripcion"
        itemTemplate={formatearMercaderia}
        emptyMessage={mensajeVacio}
        placeholder="Buscar por código o descripción"
        readOnly={SoloLectura}
        panelClassName="lista-desplegable-panel"
        panelStyle={{ color: "black", fontSize: "14px" }}
      />
    </div>
  );
}
